module.exports = __webpack_public_path__ + "static/media/renewal_modal_background.872c40c0.png";